<template>
    <div class="wallet-connect-wrapper">
        <Transition>
        <ScanOrUri v-if="isQrScanner" @gotUri="gotUri"></ScanOrUri>
    </Transition>
        <div v-if="isNotification">

            <WalletConnectNotification v-for="notification in notifications" @accept="acceptNotification"
                :isVisible="isNotVisible(notification.id)" @reject="rejectNotification"
                :notificationType="notification.type" :notificationId="notification.id" :key="notification.id"
                :notificationDetail="notification.detail" @hideNotif="hideNotification">
            </WalletConnectNotification>

        </div>
        <Transition>
        <WalletConnectButton :totalNotifications="notifications.length" :peerMeta="peerMeta" :connected="connected"
            :isOpen="isFullOpen" v-if="connector" v-show="!isFullOpen" @openScreen="openFull" @disconnect="killSession">
        </WalletConnectButton>
    </Transition>
        <WalletConnectFull :address="address" :peerMeta="peerMeta" :notifications="notifications" :connected="connected"
            :isOpen="isFullOpen" @openScreen="openFull" @makeVisibleNotif="makeVisibleNotif"
            v-if="connector && isFullOpen" @disconnect="killSession"></WalletConnectFull>

    </div>
</template>
<script>
import * as ethers from "ethers";
import { signTypedData_v4 } from "eth-sig-util";

import ScanOrUri from "./ScanOrUri.vue";
import WalletConnect from "@walletconnect/client";
import { DEFAULT_CHAIN_ID, SUPPORTED_CHAINS } from "@/walletConnect/constants";
import { getProvider } from "@/walletConnect/constants/providers";

import WalletConnectNotification from "./WalletConnectNotification.vue";
import WalletConnectButton from "./WalletConnectButton.vue";
import WalletConnectFull from "./WalletConnectFull.vue";


export default {
    data() {
        return {
            uri: '',
            connector: null,
            peerMeta: null,
            connected: null,
            chainId: 1 || DEFAULT_CHAIN_ID,
            address: null,
            isNotification: false,
            wallet: null,

            notifications: [],
            visibleNotifications: [],
            isFullOpen: false,
            supportedChains: SUPPORTED_CHAINS
        };
    },
    methods: {
        initialState() {
            this.uri = ''
            this.connector = null
            this.peerMeta = null
            this.connected = null
            this.chainId = 1 || DEFAULT_CHAIN_ID
            this.address = null
            this.isNotification = false
            this.wallet = null
            this.notifications = []
            this.visibleNotifications = []
            this.isFullOpen = false

            localStorage.removeItem('walletconnect')
        },
        async con() {
            let selectedWallet = this.selectedWallet;

            if (this.connector && this.connector.connected) {
                const lsWallets = JSON.parse(window.LS.get("wallets"))
                if (this.selectedWallet && this.isChainSupported(this.selectedWallet.chain)) {
                this.chainId = this.selectedWallet.chainId
                    selectedWallet = this.selectedWallet
                } else {
                    lsWallets.forEach((i) => {

                        let vaw = JSON.parse(window.LS.get(`w-${i}`))
                        if (vaw.address == this.connector.accounts[0]) {
                            selectedWallet = vaw
                            this.chainId = vaw.chainId

                        }
                    })
                }
            } else {
                if (!this.isChainSupported(selectedWallet.chain)) {
                    const lsWallets = JSON.parse(window.LS.get("wallets"))
                    lsWallets.forEach((i) => {

                        let vaw = JSON.parse(window.LS.get(`w-${i}`))
                        if (vaw.chain == 'ETH') {
                            selectedWallet = vaw
                            this.chainId = vaw.chainId


                        }
                    })


                }else{
                    this.chainId = this.selectedWallet.chainId
                    selectedWallet = this.selectedWallet
                }
            }


            this.address = selectedWallet.address
            let privateKey = selectedWallet.private_key;
            const provider = new ethers.providers.JsonRpcProvider(getProvider(selectedWallet.chain));
            let wallet = new ethers.Wallet(privateKey);
            wallet = wallet.connect(provider);
            this.wallet = wallet
            // Connect a wallet to mainnet
            let walletWithProvider = new ethers.Wallet(privateKey, provider);

        },
        async conWalletConnect() {
            let selectedWallet = this.selectedWallet;


            if (this.connector && this.connector.connected) {
                const lsWallets = JSON.parse(window.LS.get("wallets"))
                if (this.isChainSupported(this.selectedWallet.chain)) {
                    selectedWallet = this.selectedWallet
                    this.chainId = selectedWallet.chainId
                } else {
                    lsWallets.forEach((i) => {

                        let vaw = JSON.parse(window.LS.get(`w-${i}`))
                        if (vaw.address == this.connector.accounts[0]) {
                            selectedWallet = vaw
                            this.chainId = selectedWallet.chainId

                        }
                    })
                }
            } else {

                if (!this.isChainSupported(selectedWallet.chain)) {
                    const lsWallets = JSON.parse(window.LS.get("wallets"))
                    lsWallets.forEach((i) => {

                        let vaw = JSON.parse(window.LS.get(`w-${i}`))
                        if (vaw.chain == 'ETH') {
                            selectedWallet = vaw
                            this.chainId = selectedWallet.chainId

                            window.LS.set("selectedWallet", JSON.stringify(vaw))

                        }
                    })


                }else{
                    this.chainId = this.selectedWallet.chainId
                    selectedWallet = this.selectedWallet
                }
            }


            this.address = selectedWallet.address
            let privateKey = selectedWallet.private_key;
            const provider = new ethers.providers.JsonRpcProvider(getProvider(selectedWallet.chain));

            let wallet = new ethers.Wallet(privateKey);
            wallet = wallet.connect(provider);
            this.wallet = wallet
            // Connect a wallet to mainnet
            let walletWithProvider = new ethers.Wallet(privateKey, provider);
        },

        gotUri(uri) {
            this.uri = uri
            this.initWalletConnect()
        },

        setSession() {
            const connector = this.connector
            let session = connector.session
            if (session) {
                localStorage.setItem('walletconnect', JSON.stringify(session))

            }
        },

        async initWalletConnect() {
            const uri = this.uri;

            //this.setState({ loading: true });
            await this.conWalletConnect()
            try {
                const connector = await new WalletConnect({ uri });
                this.connector = connector
                this.setSession()
                if (!connector.connected) {
                    await connector.createSession();
                }


                this.connector = connector
                this.uri = connector.uri
                this.subscribeToEvents();
            } catch (error) {


                throw error;
            }
        },

        updateSession() {
            if (this.isChainSupported(this.selectedWallet.chain)) {
                const { connector, chainId } = this;
                const address = this.selectedWallet.address
                if (connector) {
                    connector.updateSession({
                        chainId: chainId || 1,
                        accounts: [address],
                    });
                }
                this.connector = connector
            }


        },

        subscribeToEvents() {
            console.log("ACTION", "subscribeToEvents");
            const connector = this.connector
            if (connector) {
                connector.on("session_request", (error, payload) => {
                    console.log("EVENT", "session_request");

                    if (error) {
                        throw error;
                    }
                    console.log("SESSION_REQUEST", payload.params);
                    const peerMeta = payload.params[0];
                    this.peerMeta = peerMeta.peerMeta || peerMeta
                    this.isNotification = true

                    const notification = {
                        detail: peerMeta,
                        type: '1',
                    }
                    notification.detail.address = this.address


                    this.addNotification(notification)
                    //this.approveSession()
                });

                connector.on("session_update", error => {
                    console.log("EVENT", "session_update");

                    if (error) {
                        throw error;
                    }
                });

                connector.on("call_request", async (error, payload) => {
                    // tslint:disable-next-line
                    console.log("EVENT", "call_request", "method", payload.method);
                    console.log("EVENT", "call_request", "params", payload.params, payload);

                    const notification = {

                        detail: payload.params,
                        type: payload.method,
                    }
                    if (payload && payload.id) {
                        notification.id = payload.id
                    }

                    this.addNotification(notification)
                    if (error) {
                        throw error;
                    }

                });

                connector.on("connect", (error, payload) => {
                    console.log("EVENT", "connect");

                    if (error) {
                        throw error;
                    }

                    this.connected = true
                });

                connector.on("disconnect", (error, payload) => {
                    console.log("EVENT", "disconnect");
                    this.initialState()

                    if (error) {
                        throw error;
                    }

                    //this.resetApp();
                });

                if (connector.connected) {
                    const { chainId, accounts } = connector;
                    const index = 0;
                    const address = accounts[index];
                    //this.wallet.update(index, chainId);
                    this.con()

                    this.connected = true
                    this.address = address
                    this.chainId = chainId

                }

                this.connector = connector
            }
        },


        approveSession() {
            console.log("ACTION", "approveSession");
            const connector = this.connector
            const chainId = this.chainId
            const address = this.address
            if (connector) {
                connector.approveSession({ chainId, accounts: [address] });
            }
            this.connector = connector
        },

        rejectSession() {
            console.log("ACTION", "rejectSession");
            const connector = this.connector;
            if (connector) {
                connector.rejectSession();
            }
            this.connector = connector
            this.initialState()

        },

        async approveRequest(payload) {
            const connector = this.connector
            try {

                await this.signEthereumRequests(payload)
            } catch (error) {
                console.error(error);
                if (connector) {
                    connector.rejectRequest({
                        id: payload.id,
                        error: { message: "Failed or Rejected Request" },
                    });
                }
            }


            this.connector = connector;
        },
        async rejectRequest(payload) {
            const { connector } = this;
            if (connector) {
                connector.rejectRequest({
                    id: payload.id,
                    error: { message: "Failed or Rejected Request" },
                });
            }
            this.connector = connector
        },
        killSession() {
            console.log("ACTION", "killSession");
            const connector = this.connector
            if (connector) {

                connector.killSession();
            }
            this.initialState()

        },


        acceptNotification(val) {
            if (typeof val.type == 'string') {
                if (val.type == '1') {
                    this.approveSession()

                } else {
                    const payload = {}
                    payload.method = val.type
                    payload.params = val.detail
                    payload.id = val.id
                    this.approveRequest(payload)
                }

                this.deleteNotification(val)

            }
        },

        rejectNotification(val) {
            if (typeof val.type == 'string') {
                if (val.type == '1') {
                    this.rejectSession()
                } else {
                    const payload = {}
                    payload.method = val.type
                    payload.params = val.detail
                    payload.id = val.id
                    this.rejectRequest(payload)
                }

                this.deleteNotification(val)

            }
        },
        findMissing(input) {
            let result = [];
            if (input.length > 1) {
                input = input.sort((a, b) => {
                    return a - b
                })
            }

            for (
                let i = 0, targetValue = input[0];
                targetValue <= input[input.length - 1];
                targetValue++
            ) {
                if (input[i] != targetValue) {
                    result.push(targetValue);
                } else {
                    i++;
                }
            }

            return result[0];
        },

        async addNotification(notification) {
            this.isNotification = true

            let notif = notification
            if (this.notifications.length == 0) {
                if (!notif.id) {
                    notif.id = 1
                }
            } else {
                if (!notif.id) {
                    const res = [];
                    this.notifications.forEach((e) => {

                        res.push(e.id)

                    })

                    let lower = Math.min(...res);
                    let upper = Math.max(...res);
                    let between = this.findMissing(res)
                    if (between) {
                        notif.id = between

                    } else {
                        notif.id = upper + 1
                    }
                }

            }
            this.notifications.push(notif)
            this.visibleNotifications.push(notif.id)

        },

        deleteNotification(notification) {
            let notif = [...this.notifications]

            notif = notif.filter(item => item.id !== notification.id)

            this.notifications = notif

        },

        isNotVisible(id) {
            let res = this.visibleNotifications.indexOf(id)

            return res > -1 ? true : false
        },

        hideNotification(id) {
            let notif = [...this.visibleNotifications]

            notif = notif.filter(item => item !== id)
            this.visibleNotifications = notif
        },

        async init() {
            if(this.selectedWallet && this.isChainSupported(this.selectedWallet.chain)){
                this.chainId = this.selectedWallet.chainId
            }
            let chainId = this.chainId

            const session = await this.getCachedSession()
            if (!session) {
                await this.con()
            } else {
                const connector = new WalletConnect({ session });

                const { connected, accounts, peerMeta } = connector;

                const address = accounts[0];

                chainId = connector.chainId;
                await this.con()


                this.connected = connected
                this.connector = connector
                this.address = address
                this.accounts = accounts
                this.chainId = chainId
                this.peerMeta = peerMeta

                this.subscribeToEvents();
            }
        },

        async getCachedSession() {
            const local = await localStorage ? localStorage.getItem("walletconnect") : null;
            let session = null;
            if (local) {
                try {
                    session = await JSON.parse(local);
                    this.connector = session
                } catch (error) {
                    throw error;
                }
            }
            return session;
        },

        async signEthereumRequests(payload) {
            const { connector, address } = this;
            let errorMsg = "";
            let result = null;

            if (connector) {
                if (!this.wallet) {
                    await this.con();
                }

                let transaction = null;
                let dataToSign = null;
                let addressRequested = null;

                switch (payload.method) {
                    case "eth_sendTransaction":
                        transaction = payload.params[0];
                        addressRequested = transaction.from;
                        if (address.toLowerCase() === addressRequested.toLowerCase()) {
                            result = await this.sendTransaction(transaction);
                        } else {
                            errorMsg = "Address requested does not match active account";
                        }
                        break;
                    case "eth_signTransaction":
                        transaction = payload.params[0];
                        addressRequested = transaction.from;
                        if (address.toLowerCase() === addressRequested.toLowerCase()) {
                            result = await this.signTransaction(transaction);
                        } else {
                            errorMsg = "Address requested does not match active account";
                        }
                        break;
                    case "eth_sign":
                        dataToSign = payload.params[1];
                        addressRequested = payload.params[0];
                        if (address.toLowerCase() === addressRequested.toLowerCase()) {
                            result = await this.wallet.signMessage(dataToSign);
                        } else {
                            errorMsg = "Address requested does not match active account";
                        }
                        break;
                    case "personal_sign":
                        dataToSign = payload.params[0];
                        addressRequested = payload.params[1];
                        if (address.toLowerCase() === addressRequested.toLowerCase()) {
                            result = await this.signPersonalMessage(dataToSign);
                        } else {
                            errorMsg = "Address requested does not match active account";
                        }
                        break;
                    case "eth_signTypedData":
                        dataToSign = payload.params[1];
                        addressRequested = payload.params[0];
                        if (address.toLowerCase() === addressRequested.toLowerCase()) {
                            result = await this.signTypedData(dataToSign);
                        } else {
                            errorMsg = "Address requested does not match active account";
                        }
                        break;
                    default:
                        break;
                }
                if (result) {
                    connector.approveRequest({
                        id: payload.id,
                        result,
                    });
                } else {
                    let message = "JSON RPC method not supported";
                    if (errorMsg) {
                        message = errorMsg;
                    }

                    connector.rejectRequest({
                        id: payload.id,
                        error: { message },
                    });
                }
            }
        },
        openFull(e) {
            this.isFullOpen = e
        },
        makeVisibleNotif(id) {
            this.visibleNotifications.push(id)
        },

        isChainSupported(chain) {
            let sc = [...this.supportedChains]
            let result = sc.find(e => {
                return e.chain == chain
            })
            return result
        },
        //transactions
        async sendTransaction(transaction) {
            if (this.wallet) {
                if (
                    transaction.from &&
                    transaction.from.toLowerCase() !== this.wallet.address.toLowerCase()
                ) {
                }

                if (transaction.from) {
                    delete transaction.from;
                }

                // ethers.js expects gasLimit instead
                if ("gas" in transaction) {
                    transaction.gasLimit = transaction.gas;
                    delete transaction.gas;
                }

                const result = await this.wallet.sendTransaction(transaction);
                return result.hash;
            } else {
            }
            return null;
        },

        async signTransaction(data) {
            if (this.wallet) {
                if (data && data.from) {
                    delete data.from;
                }
                data.gasLimit = data.gas;
                delete data.gas;
                const result = await this.wallet.signTransaction(data);
                return result;
            } else {
                console.error("No Active Account");
            }
            return null;
        },
        async signMessage(data) {

            if (this.wallet) {
                const signingKey = new ethers.utils.SigningKey(this.wallet.privateKey);
                const arrify = ethers.utils.arrayify(data)
                const sigParams = await signingKey.signDigest(arrify);
                const result = await ethers.utils.joinSignature(sigParams);
                return result;
            } else {
                console.error("No Active Account");
            }
            return null;
        },

        async signPersonalMessage(message) {
            if (this.wallet) {
                const result = await this.wallet.signMessage(
                    ethers.utils.isHexString(message) ? ethers.utils.arrayify(message) : message,
                );
                return result;
            } else {
                console.error("No Active Account");
            }
            return null;
        },

        async signTypedData(data) {
            if (this.wallet) {
                const result = signTypedData_v4(Buffer.from(this.wallet.privateKey.slice(2), "hex"), {
                    data: JSON.parse(data),
                });
                return result;
            } else {
                console.error("No Active Account");
            }
            return null;
        }

    },
    computed: {
        isQrScanner: {
            get() {
                return this.$store.state.isQrScanner
            },
            set(value) {
                this.$store.dispatch('setIsQrScanner', value)
            }
        },

        selectedWallet: {
            get() {
                return this.$store.state.hdSelectedWallet
            }
        }
    },

    watch: {
        "selectedWallet": {
            immediate:true,
            handler(val) {
                this.con()
                this.updateSession()
            }
        }
    },
    mounted() {
        this.init();
    },
    components: { ScanOrUri, WalletConnectNotification, WalletConnectButton, WalletConnectFull }
}
</script>
<style scoped lang="scss">
.v-enter-active,
.v-leave-active {
    transition: all 1s ease;
}

.v-enter-from,
.v-leave-to {
    transform: translateY(150%);
}

</style>